<template>
  <div id="literature-cart" class="cart-wrapper" v-show="!isHidden" >
    <div class="in-cart">

      <a class="cart-icon-container" @click.prevent="toggle=!toggle">
        <div class="cart-icon" >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 294.66 352.36" :style="{  }">
            <title>Cart</title>
            <path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="30"
                  d="M15 337.36h264.66l-13.7-242H28.7l-13.7 242z"/>
            <path
              d="M80.53 119.36A19.68 19.68 0 10100.21 139a19.7 19.7 0 00-19.68-19.68M213.53 119.36A19.68 19.68 0 10233.21 139a19.7 19.7 0 00-19.68-19.68"
              fill="currentColor"/>
            <path d="M80.86 141V79.37a68.08 68.08 0 0119.56-48 64.94 64.94 0 0193.49 0 68.12 68.12 0 0119.56 48V141" fill="none"
                  stroke="currentColor" stroke-miterlimit="10" stroke-width="23.07"/>
          </svg>
          <span class="cart-number">{{ cart.length }}</span>
        </div>
        <h3 class="cart-title">
          Physical Request
          <svg class="arrow-up" :style="{ transform: toggle ? 'rotate(0)' : 'rotate(180deg)' }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"/></svg>
        </h3>
      </a>

      <div class="cart-items" v-if="toggle">

        <div v-if="!cart.length" class="cart-is-empty" >
          <p>No items in cart</p>
        </div>

<!--        <div v-else class="close-cart">-->
<!--          <a href="#" @click.prevent="toggle=!toggle"></a>-->
<!--        </div>-->

        <div v-for="item in cart"
             :key="item.id"
             class="cart-item"
        >
          <a class="close-icon" href="#" @click.prevent="() => onRemoveItem(item.id)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
              <path fill-rule="evenodd" fill="currentColor" d="M12.888 10.751l-2.121 2.121L6.505 8.61l-4.243 4.243-2.121-2.121 4.242-4.243L.141 2.246 2.262.125l4.243 4.242L10.747.125l2.121 2.122-4.242 4.242 4.262 4.262z"/>
            </svg>
          </a>
          <div class="cart-item-content" @click="() => onItemClick(item.id)">
            <h3 class="item-title" >{{ item.title }}</h3>
            <div class="item-quantity"><span>Qty: </span>{{ item.quantity }}</div>
          </div>

        </div>

        <a href="#stage" class="place-request"
           v-if="cart.length > 0"
           @click.prevent="onPlaceRequest"
        >
          Place Order
        </a>

      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import stickybits from "stickybits";

  import EventBus from './LiteratureEventBus';
  import {
    EVENT_LITERATURE_CART_REMOVE_ITEM,
    EVENT_LITERATURE_CART_UPDATE_ITEMS,
    EVENT_LITERATURE_PLACE_REQUEST,
    EVENT_LITERATURE_CART_FOCUS_ITEM
  } from "../constants";

  export default {
    name: "LiteratureCart",
    // props: {
    //   cart: {
    //     type: Array,
    //     default: [],
    //   },
    //   nextHandler: {
    //     type: Function,
    //     default: () => {}
    //   },
    //   itemRemoveHandler: {
    //     type: Function,
    //     default: (id) => {}
    //   }
    // },
    data() {
      return {
        cart: [],
        toggle: true,
        isHidden: false,
      }
    },
    methods: {
      onPlaceRequest() {
        EventBus.$emit(EVENT_LITERATURE_PLACE_REQUEST, true)
      },
      onRemoveItem(id) {
        EventBus.$emit(EVENT_LITERATURE_CART_REMOVE_ITEM, id);
      },
      onItemClick(id) {
        EventBus.$emit(EVENT_LITERATURE_CART_FOCUS_ITEM, id);
      }
    },
    mounted() {
      EventBus.$on(EVENT_LITERATURE_CART_UPDATE_ITEMS, (items) => {
        Vue.set(this, 'cart', items);
      });
      EventBus.$on(EVENT_LITERATURE_PLACE_REQUEST, (payload) => {
        this.isHidden = !!payload;
      });

      stickybits('#literature-cart');
    }
  }
</script>
